export const useCdnUrl = () => {
  const config = useRuntimeConfig();
  return config.app.cdnURL;
};
